module.exports = __webpack_public_path__ + "static/media/flag-az.56d0ecc0.webp";